import { Component } from '@theme/component';

class StickyAtc extends Component {
  #observer;
  #mutationObserver;
  #stickyButton;
  #mainButton;

  connectedCallback() {
    super.connectedCallback();

    this.#stickyButton = this.querySelector('button');

    const mainAtc = document.querySelector('product-form-component:not([class]) add-to-cart-component');
    if (!mainAtc) return;

    this.#mainButton = mainAtc.querySelector('button[type="submit"]');
    if (!this.#mainButton) return;

    // Sync initial disabled state
    this.#stickyButton.disabled = this.#mainButton.disabled;

    // Watch main ATC visibility
    this.#observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.classList.remove('is-visible');
        } else {
          this.classList.add('is-visible');
        }
      },
      { threshold: 0 }
    );
    this.#observer.observe(mainAtc);

    // Mirror disabled state changes
    this.#mutationObserver = new MutationObserver(() => {
      this.#stickyButton.disabled = this.#mainButton.hasAttribute('disabled');
    });
    this.#mutationObserver.observe(this.#mainButton, {
      attributes: true,
      attributeFilter: ['disabled'],
    });

    // Submit the main product form and trigger its animation
    this.#stickyButton.addEventListener('click', () => {
      if (!this.#mainButton) return;
      this.#mainButton.closest('add-to-cart-component')?.animateAddToCart?.();
      this.#mainButton.closest('product-form-component')?.querySelector('form')?.requestSubmit();
    });
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#mutationObserver?.disconnect();
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}
